import { useFetchAssets } from 'src/Hooks/Queries/useFetchAssets';
import useFetchUser from 'src/Hooks/Queries/useFetchUser';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

/**
 * Bien courant, y compris sur les pages qui ne portent pas `:assetId` dans leur URL —
 * les anciennes URLs `/community…`, conservées pour les notifications, y redirigent.
 *
 * Ordre de résolution : le bien de l'URL, sinon le favori de l'utilisateur (la même
 * source que le sélecteur du header), sinon le premier bien accessible.
 */
export const useSelectedAssetId = (): string | undefined => {
  const routeAssetId = useCurrentAssetId();
  const { data: assets } = useFetchAssets();
  const { data: me } = useFetchUser();

  if (routeAssetId) return routeAssetId;
  if (!assets || assets.length === 0) return undefined;

  const favorite = me?.favoriteAssetId
    ? assets.find(asset => asset.id === me.favoriteAssetId)
    : undefined;

  return (favorite ?? assets[0]).id;
};
